import styles from "./LimitCurrencyConverter.module.css"
import LimitCurrencySelector from "../LimitCurrencySelector/LimitCurrencySelector"
import LimitPrice from "../LimitAmount/LimitPrice"
import { FaTimes, FaDivide } from "react-icons/fa"
import { useState} from "react"

const LimitCurrencyConverter = (props) => {
  const { isLiq, handleAllowedButton } = props
  const [ divisionIcon, setDivisionIcon] = useState(false)

  return (
    <section className={styles.currency_converter}> 
      <LimitPrice handleAllowedButton={ handleAllowedButton} />
      {/* <div className={styles.times_icon} onClick={() => setDivisionIcon(!divisionIcon)}>
        {divisionIcon ?
          <FaTimes size={25} />
          :
          <FaDivide size={25} />
        
      }

      </div> */}

    {<LimitCurrencySelector direction={"Amount"}
      field_Id='limit-sell'
      sellToken

    
    />}
        <div className={styles.arrow_container}>
      {isLiq ? null : <span className={styles.arrow} />}
        </div>
    <LimitCurrencySelector direction={"You receive"}
      field_Id='limit-buy'
      
            />
  </section>
  )
}

export default LimitCurrencyConverter